import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueResource from 'vue-resource'  //使用get post jsonp时放开
import vant from 'vant'
import  TimePicker  from 'element-ui/lib/time-picker';
import  Icon  from 'element-ui/lib/icon';

import store from './store';
import filter from "@/theme/filter";
import derictives from "@/theme/derictives/index";
import '@/assets/css/common.scss'
import '@/assets/css/animate.min.css'
import fetch from './assets/js/fetch'

Vue.component('el-time-picker',TimePicker)
Vue.component('el-icon',Icon)
Vue.use(VueResource)
Vue.use(vant);
Vue.config.productionTip = false;
Vue.prototype.fetch = fetch;
Vue.prototype.domain = process.env.VUE_APP_URI_DOMAIN;

new Vue({
  router,
  store,
  data: {
    eventHub: new Vue()
  },
  render: (h) => h(App),
}).$mount('#app');

Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})

Object.keys(derictives).forEach(key => {
  Vue.directive(key, derictives[key])
})
